module.exports = __webpack_public_path__ + "img/sand-dune-decal-13.105ceae7.png";